import React from 'react';
import PropTypes from 'prop-types';
import { X } from '@phosphor-icons/react';
import { format } from 'date-fns';
import { convertCustomDateFormatToISO } from '../../../utils/commonUtils';

const SelectedEvent = ({ event, onBackToStep1 }) => {
  return (
    <div className='flex justify-between items-start border border-black rounded-lg p-5'>
      <div className='flex flex-col gap-2'>
        <div className='heading-18'>{event.name}</div>
        <div className='label-14 text-grey-70'>{format(convertCustomDateFormatToISO(event?.start_date), 'iii, MMM d, hh:mm a')}</div>
      </div>
      <X size={24} 
        color='#101010' 
        onClick={onBackToStep1} 
        className='cursor-pointer'
      />
    </div>
  );
};

SelectedEvent.propTypes = {
  event: PropTypes.shape({
    title: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
  }).isRequired,
  onBackToStep1: PropTypes.func.isRequired,
};

export default SelectedEvent;
